webpackJsonp([57],{

/***/ 2032:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2033);


/***/ }),

/***/ 2033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
    (0, _jquery2.default)('.collapsable .title').on('click', function (ev) {
        var $target = (0, _jquery2.default)(ev.target);
        $target.parent().toggleClass('open');
        $target.siblings('.copy').slideToggle('fast');
        return false;
    });
});

/***/ })

},[2032]);


// WEBPACK FOOTER //
// presentation/help-e8cde7417c22b58b30e9.js